import { API, createPath } from "../helpers"
import { AttributeType, Order } from "./commerce.interface"
import { NETLIFY_URL } from "./constants"

export enum Include {
  LineItems = "line_items",
  Shipments = "shipments",
  PaymentSource = "payment_source",
  PaymentMethod = "payment_method",
  AvailablePaymentMethods = "available_payment_methods",
  ShippingAddress = "shipping_address",
  BillingAddress = "billing_address",
}

export enum Status {
  Draft = "draft",
  Pending = "pending",
  Placed = "placed",
  Approved = "approved",
  Cancelled = "cancelled",
}

export const createOrder = (marketId: string, email?: string) =>
  API.post(`${NETLIFY_URL}/create-order`, {
    body: {
      data: {
        type: AttributeType.Order,
        ...(email && {
          attributes: {
            customer_email: email,
          },
        }),
        relationships: {
          market: {
            data: {
              type: AttributeType.Market,
              id: marketId,
            },
          },
        },
      },
    },
  })

export const getUserOrders = async (userId: string) =>
  API.get(createPath(`${NETLIFY_URL}/get-user-orders`, { id: userId }))

export const getOrder = async (orderId: string) =>
  API.get(
    createPath(`${NETLIFY_URL}/get-order`, {
      orderId,
      include: Object.values(Include).join(","),
    })
  )

export const isOrderOfStatus = (order: Order | undefined, status: Status) =>
  order ? order.data.attributes.status === status : false

export const isOrderPending = (order?: Order) =>
  isOrderOfStatus(order, Status.Pending)
export const isOrderPlaced = (order?: Order) =>
  isOrderOfStatus(order, Status.Placed)
export const isOrderFinished = (order?: Order) =>
  isOrderOfStatus(order, Status.Placed) ||
  isOrderOfStatus(order, Status.Approved) ||
  isOrderOfStatus(order, Status.Cancelled)
